// Badge d'Estat editable, reutilitzat a totes les fitxes "document" de l'ERP
// (abans cada formulari implementava el seu propi desplegable o barrejava un
// badge de lectura a la capçalera amb un <select> duplicat al cos).
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export interface StatusOption {
  code: string;
  name: string;
  className?: string;
  dot?: string;
}

export default function StatusSelect({ value, options, onChange, fallbackLabel }: {
  value: string;
  options: StatusOption[];
  onChange: (code: string) => void;
  fallbackLabel?: string;
}) {
  const [open, setOpen] = useState(false);
  const current = options.find((o) => o.code === value);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium hover:opacity-80 transition-opacity ${current?.className ?? 'bg-gray-100 text-gray-700'}`}
      >
        {current?.name ?? fallbackLabel ?? value}
        <ChevronDown size={12} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-full mt-1 z-40 bg-white border border-gray-200 rounded-lg shadow-lg py-1 min-w-[160px]">
            {options.filter((o) => o.code !== value).map((o) => (
              <button
                key={o.code}
                type="button"
                onClick={() => { onChange(o.code); setOpen(false); }}
                className="flex items-center gap-2 w-full px-3 py-1.5 text-left text-xs hover:bg-gray-50 transition-colors"
              >
                <span className={`inline-block w-2 h-2 rounded-full ${o.dot ?? 'bg-gray-300'}`} />
                {o.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
